import { Component, OnInit, Input } from '@angular/core';
import { Validators, UntypedFormBuilder, ValidationErrors } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'src/app/api.service';
import { FunctionsService } from 'src/app/services/functions.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.css'],
  providers: [NgxSpinnerService]
})

export class VerifyEmailComponent implements OnInit {
  @Input() set userEmail(value: any) {
    this.email = value;
  }
  @Input() set userName(value: any) {
    this.name = value;
  }
  @Input() set userLang(value: any) {
    this.lang = value;
  }
  constructor(
    private formBuilder: UntypedFormBuilder,
    public functionsService: FunctionsService,
    public activeModal: NgbActiveModal,
    private apiService: ApiService,
    private modalService: NgbModal,
    private translate: TranslateService,
    private spinnerM: NgxSpinnerService,
    private router: Router) { }

  email: any;
  name: any;
  formSubmitted: boolean = false;
  lang:string;

  verifyEmailForm = this.formBuilder.group({
    VerificationCode: ['', [Validators.required]],
  });

  
  ngOnInit() {
  }

  verifyCode(){
    this.spinnerM.hide();
    Object.keys(this.verifyEmailForm.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.verifyEmailForm.get(key).errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });
      
    if (!this.verifyEmailForm.valid) {
        this.formSubmitted = true;
        return;
    } 
   
    this.apiService.validateCode({"Email":this.email,"Code":this.verifyEmailForm.value.VerificationCode}).subscribe(
        data => {
            if(!data){
              document.getElementById('code_error').innerText = this.translate.instant('register.invalid_code');
              this.translate.onLangChange.subscribe(() => { 
                document.getElementById('code_error').innerText = this.translate.instant('register.invalid_code');
              });
            }else{
                this.activeModal.close();
                this.modalService.dismissAll();
                //Go to cart (login user)
                this.router.navigateByUrl('/main');
            }
          //Redirect user to portal
        },
        error => {
          this.functionsService.errorHandler(error["status"]);
        }
    );
  }

  resendCode(){
    this.spinnerM.show();
    document.getElementById("re-sent").innerHTML = "";
    this.translate.onLangChange.subscribe(() => { 
      document.getElementById("re-sent").innerHTML = "";
    });
    var language = this.lang.toUpperCase();
    this.apiService.resendCode({"Email":this.email,"Name":this.name,"Language":language}).subscribe(
        () => {
          this.spinnerM.hide();
          document.getElementById("re-sent").innerHTML = this.translate.instant("register.code_re-sent")+ " " + this.email;
          this.translate.onLangChange.subscribe(() => { 
            document.getElementById("re-sent").innerHTML = this.translate.instant("register.code_re-sent")+ " " + this.email;
          });
        },
        error => {
          this.spinnerM.hide();
          this.functionsService.errorHandler(error["status"]);
        }
    );
  }

  get VerificationCode() { return this.controlGetter('VerificationCode'); }

  controlGetter(controlName) {
    const control =  this.verifyEmailForm.get(controlName);
    return control && (control.touched || this.formSubmitted) ? control : {};
  }
}
